import * as React from 'react';

import {ActionMenu} from 'shells/action-menu/action-menu';
import {ConfirmationDialog} from 'shells/confirmation-dialog/confirmation-dialog';
// @ts-expect-error - imported from .js/.jsx file
import {TrashIcon} from 'shells/icon/svg/trash-icon';

type Props = {
    onDeleteSubdomain: () => Promise<any>;
};

export function SubdomainRowActionMenu(props: Props) {
    const [isConfirmingDelete, setIsConfirmingDelete] = React.useState<boolean>(false);
    const actionMenuRef = React.useRef();

    return (
        <>
            <ActionMenu
                options={[
                    {
                        label: 'Delete',
                        handleSelect: () => setIsConfirmingDelete(true),
                        icon: <TrashIcon size={16} />,
                        variant: 'destructive',
                    },
                ]}
                getRef={(node) => {
                    // @ts-expect-error
                    actionMenuRef.current = node;
                }}
            />
            {isConfirmingDelete && (
                <ConfirmationDialog
                    title='Are you sure you want to delete this subdomain?'
                    message='Any landing pages currently hosted on this subdomain will no longer be accessible through their custom URLs.'
                    onCancel={() => setIsConfirmingDelete(false)}
                    onConfirm={() => {
                        props.onDeleteSubdomain().then(() => setIsConfirmingDelete(false));
                    }}
                />
            )}
        </>
    );
}
